(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["theodore-editorial"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('theodore-mesh')) {
    /* How it runs (9 Oct 2026). Everything that draws is one self-contained
       function, paintMesh. Where the browser can, a Worker runs it on a canvas
       handed over with transferControlToOffscreen(), so no frame touches the
       page's main thread and the animation carries on through scrolls and taps.
       The worker's script is paintMesh's own text in a Blob, which survives the
       theme's minifier and keeps one copy of the drawing code. Without
       OffscreenCanvas, or if the worker will not start, the same function draws
       on the page. Either way it starts once the page has loaded and gone idle,
       draws at ~30 fps (~24 for contours) only while the section is near the
       screen and the tab is visible, and draws one still frame, with no worker,
       for reduced motion or save-data.

       Cost (homepage, 375px, 4x CPU). Drawn on the page, a warp frame is ~1 ms
       of script but forces a whole rendering pass (intersection observers,
       commit), ~300 ms of main thread a second while on screen. So from 24 Sep
       2026 (strokes batched, ~700 a frame down to ~14) it held still for a
       second after any touch, scroll or key, which on a phone froze it for the
       whole of every scroll. In the worker the page does no rendering for it at
       all, so nothing waits behind a frame and it never needs to hold still. */

    // Everything that draws. It is also the worker's source, so it must use nothing
    // from outside its own body. Returns the message handler: init {canvas, mode,
    // dark, still}, size {w, h, dpr}, run, stop, hush {ms}; false means no 2D context.
    const paintMesh = function paintMesh() {
      const TRAIL = 7; // warp trail samples at ~30 fps: the same length as 14 at 60
      const hash = (n) => { const x = Math.sin(n * 12.9898 + 78.233) * 43758.5453; return x - Math.floor(x); };
      const hash2 = (x, y) => hash(x * 1.7 + y * 113.1);
      const fade = (t) => t * t * t * (t * (t * 6 - 15) + 10);
      // value noise on a unit lattice, quintic-smoothed
      const noise2 = (x, y) => {
        const ix = Math.floor(x), iy = Math.floor(y);
        const fx = x - ix, fy = y - iy;
        const a = hash2(ix, iy), b = hash2(ix + 1, iy), c = hash2(ix, iy + 1), d = hash2(ix + 1, iy + 1);
        const u = fade(fx), v = fade(fy);
        return a + (b - a) * u + (c - a) * v + (a - b - c + d) * u * v;
      };

      class Scene {
        constructor(m, ctx) {
          this.canvas = m.canvas;
          this.ctx = ctx;
          this.mode = m.mode;
          this.dark = m.dark;
          this.still = m.still;
          this.t = 0; // the scene's own clock, which moves only while the loop runs
          this.w = this.h = this.sw = this.sh = 0;
        }
        size(w, h, dpr) {
          this.w = w;
          this.h = h;
          this.canvas.width = Math.round(w * dpr);
          this.canvas.height = Math.round(h * dpr);
          this.ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
          // A new width, or a height more than a tenth different, lays the scene out
          // afresh. A smaller change (a late font, a rewrapped line) keeps every
          // particle where it is: reseeding sends the warp back to its start.
          if (Math.abs(w - this.sw) >= 1 || Math.abs(h - this.sh) > this.sh * 0.1) {
            this.sw = w;
            this.sh = h;
            if (this.mode === 'mesh') this.seedMesh(); else if (this.mode === 'warp') this.seedWarp(); else this.seedContours();
          } else if (this.mode === 'contours') {
            this.seedContours(); // just the sampling grid, which must match the canvas
          }
          this.draw(this.t, 0);
        }

        /* ---- warp: particles running along the threads of a cloth as it drapes ----
           Sixteen lanes (twelve on a phone) rise and fall on two slow waves; each
           thread carries a few specks with a short hairline behind them, a
           handful in tan. Sean's pick from the 10 Sep 2026 preview. */
        seedWarp() {
          const lanes = this.w < 700 ? 12 : 16;
          const pts = [];
          let k = 0;
          for (let l = 0; l < lanes; l++) {
            const base = (l + 0.5) * (this.h / lanes);
            const per = 3 + Math.round(hash(k++ * 0.37) * 3);
            for (let j = 0; j < per; j++) {
              const r = k++ * 0.6180339;
              pts.push({ x: hash(r) * this.w, base, lane: l, v: (12 + hash(r + 1) * 12) / 1000, h: [], tan: hash(r + 2) < 0.14, ph: hash(r + 3) * 6.2832 });
            }
          }
          this.warp = { pts, amp: Math.max(8, this.h * 0.035), len: Math.max(260, this.w * 0.36) };
          // Stroke styles per trail step, built once rather than per segment per frame.
          const ink = this.dark ? '242,244,243' : '34,51,59';
          const tan = '169,146,125';
          const ramp = (rgb, k) => Array.from({ length: TRAIL }, (_, i) => 'rgba(' + rgb + ',' + (0.03 + (i / TRAIL) * k).toFixed(3) + ')');
          this.warpStyles = { ink: ramp(ink, 0.17), tan: ramp(tan, 0.26), inkHead: 'rgba(' + ink + ',0.36)', tanHead: 'rgba(' + tan + ',0.55)' };
        }
        warpY(p, x, t) {
          const w = this.warp;
          return p.base + Math.sin(x / w.len + t * 0.00028 + p.lane * 0.55) * w.amp
                        + Math.sin(x / (w.len * 0.43) - t * 0.00019 + p.ph) * w.amp * 0.35;
        }
        drawWarp(t, dt) {
          const c = this.ctx, w = this.w, h = this.h;
          if (!this.warp) return;
          c.clearRect(0, 0, w, h);
          const pts = this.warp.pts;
          for (const p of pts) {
            if (!this.still) {
              p.x += p.v * dt;
              if (p.x > w + 12) { p.x = -12; p.h = []; }
              p.h.push([p.x, this.warpY(p, p.x, t)]);
              if (p.h.length > TRAIL) p.h.shift();
            } else if (!p.h.length) {
              for (let i = TRAIL - 1; i >= 0; i--) { const x = p.x - i * 4.4; p.h.push([x, this.warpY(p, x, 0)]); }
            }
          }
          c.lineWidth = 1;
          c.lineCap = 'round';
          // One path per colour and trail step: the newest segment of every thread in one
          // stroke, the one before it in the next, and so on.
          for (const tan of [false, true]) {
            const styles = tan ? this.warpStyles.tan : this.warpStyles.ink;
            for (let i = 1; i < TRAIL; i++) {
              let any = false;
              c.beginPath();
              for (const p of pts) {
                if (p.tan !== tan) continue;
                const k = p.h.length - TRAIL + i;
                if (k < 1) continue;
                c.moveTo(p.h[k - 1][0], p.h[k - 1][1]);
                c.lineTo(p.h[k][0], p.h[k][1]);
                any = true;
              }
              if (any) { c.strokeStyle = styles[i]; c.stroke(); }
            }
            const r = tan ? 1.5 : 1.15;
            let any = false;
            c.beginPath();
            for (const p of pts) {
              if (p.tan !== tan || !p.h.length) continue;
              const head = p.h[p.h.length - 1];
              c.moveTo(head[0] + r, head[1]);
              c.arc(head[0], head[1], r, 0, 6.2832);
              any = true;
            }
            if (any) { c.fillStyle = tan ? this.warpStyles.tanHead : this.warpStyles.inkHead; c.fill(); }
          }
        }

        /* ---- contours: marching squares over a slowly drifting value-noise field ---- */
        seedContours() {
          this.cell = this.w < 700 ? 12 : 10;
          this.cols = Math.ceil(this.w / this.cell) + 1;
          this.rows = Math.ceil(this.h / this.cell) + 1;
          this.grid = new Float32Array(this.cols * this.rows);
        }
        field(x, y, t) {
          const s = 0.0000045; // drift: a few pixels a second, felt rather than seen
          return 0.62 * noise2(x / 190 + t * s, y / 190 + t * s * 0.7)
               + 0.28 * noise2(x / 82 - t * s * 0.8, y / 82 + t * s * 1.1)
               + 0.10 * noise2(x / 38 + 3.1, y / 38 - 7.7 + t * s * 1.6);
        }
        drawContours(t) {
          const c = this.ctx, w = this.w, h = this.h, cell = this.cell, cols = this.cols, rows = this.rows, g = this.grid;
          const tt = this.still ? 0 : t;
          for (let j = 0; j < rows; j++) for (let i = 0; i < cols; i++) g[j * cols + i] = this.field(i * cell, j * cell, tt);
          c.clearRect(0, 0, w, h);
          const ink = this.dark ? '242,244,243' : '34,51,59';
          c.lineWidth = 0.75;
          c.lineCap = 'round';
          const levels = 11;
          for (let l = 0; l < levels; l++) {
            const iso = 0.30 + (l / (levels - 1)) * 0.40;
            const index = l % 3 === 1; // every third contour drawn a touch firmer, as on a survey map
            c.strokeStyle = 'rgba(' + ink + ',' + (index ? 0.115 : 0.07) + ')';
            c.beginPath();
            for (let j = 0; j < rows - 1; j++) {
              for (let i = 0; i < cols - 1; i++) {
                const a = g[j * cols + i], b = g[j * cols + i + 1], cc = g[(j + 1) * cols + i + 1], d = g[(j + 1) * cols + i];
                const code = (a > iso ? 8 : 0) | (b > iso ? 4 : 0) | (cc > iso ? 2 : 0) | (d > iso ? 1 : 0);
                if (code === 0 || code === 15) continue;
                const x = i * cell, y = j * cell;
                const top = [x + cell * (iso - a) / (b - a), y];
                const right = [x + cell, y + cell * (iso - b) / (cc - b)];
                const bottom = [x + cell * (iso - d) / (cc - d), y + cell];
                const left = [x, y + cell * (iso - a) / (d - a)];
                const seg = (p, q) => { c.moveTo(p[0], p[1]); c.lineTo(q[0], q[1]); };
                switch (code) {
                  case 1: case 14: seg(left, bottom); break;
                  case 2: case 13: seg(bottom, right); break;
                  case 3: case 12: seg(left, right); break;
                  case 4: case 11: seg(top, right); break;
                  case 5: seg(top, left); seg(bottom, right); break;
                  case 6: case 9: seg(top, bottom); break;
                  case 7: case 8: seg(top, left); break;
                  case 10: seg(top, right); seg(left, bottom); break;
                }
              }
            }
            c.stroke();
          }
        }

        /* ---- mesh: pattern marks joined by hairlines, with a scan line ---- */
        seedMesh() {
          const step = this.w < 700 ? 84 : 104;
          const pts = [];
          let i = 0;
          for (let y = step / 2; y < this.h; y += step) {
            for (let x = step / 2; x < this.w; x += step) {
              const k = i++ * 0.6180339;
              pts.push({
                i,
                x: x + (hash(k) - 0.5) * step * 0.85,
                y: y + (hash(k + 1) - 0.5) * step * 0.85,
                ax: 2 + hash(k + 2) * 4,
                ay: 2 + hash(k + 3) * 4,
                px: hash(k + 4) * 6.2832,
                py: hash(k + 5) * 6.2832,
                sx: 0.00012 + hash(k + 6) * 0.00012,
                sy: 0.00012 + hash(k + 7) * 0.00012,
              });
            }
          }
          for (const p of pts) {
            p.n = pts
              .filter((q) => q !== p)
              .map((q) => ({ q, d: Math.hypot(q.x - p.x, q.y - p.y) }))
              .sort((a, b) => a.d - b.d)
              .slice(0, 2)
              .filter((o) => o.d < step * 1.35)
              .map((o) => o.q);
          }
          this.pts = pts;
        }
        drawMesh(t) {
          const c = this.ctx;
          if (!this.pts) return;
          const w = this.w, h = this.h;
          c.clearRect(0, 0, w, h);
          const ink = this.dark ? '242,244,243' : '34,51,59';
          const tan = '169,146,125';
          const cycle = 20000;
          const phase = (t % cycle) / cycle;
          const scanY = !this.still && phase < 0.62 ? (phase / 0.62) * h : -1;
          const glowAt = (y) => (scanY < 0 ? 0 : Math.max(0, 1 - Math.abs(y - scanY) / 110));
          for (const p of this.pts) {
            p.cx = this.still ? p.x : p.x + Math.sin(t * p.sx + p.px) * p.ax;
            p.cy = this.still ? p.y : p.y + Math.cos(t * p.sy + p.py) * p.ay;
          }
          c.lineWidth = 0.75;
          c.lineCap = 'butt';
          for (const p of this.pts) {
            for (const q of p.n) {
              if (q.i < p.i && q.n.includes(p)) continue;
              const g = glowAt((p.cy + q.cy) / 2);
              c.strokeStyle = 'rgba(' + ink + ',' + (0.065 + g * 0.12).toFixed(3) + ')';
              c.beginPath();
              c.moveTo(p.cx, p.cy);
              c.lineTo(q.cx, q.cy);
              c.stroke();
            }
          }
          c.lineWidth = 1;
          for (const p of this.pts) {
            const g = glowAt(p.cy);
            c.strokeStyle = 'rgba(' + ink + ',' + (0.16 + g * 0.3).toFixed(3) + ')';
            const a = 3;
            c.beginPath();
            c.moveTo(p.cx - a, p.cy + 0.5);
            c.lineTo(p.cx + a, p.cy + 0.5);
            c.moveTo(p.cx + 0.5, p.cy - a);
            c.lineTo(p.cx + 0.5, p.cy + a);
            c.stroke();
          }
          if (scanY >= 0) {
            const y = Math.round(scanY) + 0.5;
            const grad = c.createLinearGradient(0, 0, w, 0);
            grad.addColorStop(0, 'rgba(' + tan + ',0)');
            grad.addColorStop(0.5, 'rgba(' + tan + ',0.26)');
            grad.addColorStop(1, 'rgba(' + tan + ',0)');
            c.strokeStyle = grad;
            c.beginPath();
            c.moveTo(0, y);
            c.lineTo(w, y);
            c.stroke();
          }
        }

        draw(t, dt) {
          if (!this.ctx) return;
          if (this.mode === 'mesh') this.drawMesh(t); else if (this.mode === 'warp') this.drawWarp(t, dt || 0); else this.drawContours(t);
        }
      }

      let scene = null;
      let running = false, timer = 0, raf = 0, last = 0, quiet = 0;
      const hasRaf = typeof requestAnimationFrame === 'function';
      const step = (ts) => {
        raf = 0;
        if (!running) return;
        const dt = last ? Math.min(66, ts - last) : 0;
        last = ts;
        scene.t += dt;
        scene.draw(scene.t, dt);
        tick();
      };
      // A timer paces the frames so nothing renders between them, and sits out a hush;
      // where the scope has requestAnimationFrame (pages, and workers in every browser
      // that has OffscreenCanvas) it then lines each draw up with the display.
      const tick = () => {
        const frame = scene.mode === 'contours' ? 42 : 33; // ~24 fps for contours, ~30 otherwise
        timer = setTimeout(() => {
          timer = 0;
          if (performance.now() < quiet) { last = 0; tick(); }
          else if (hasRaf) raf = requestAnimationFrame(step);
          else step(performance.now());
        }, Math.max(hasRaf ? frame - 4 : frame, quiet - performance.now()));
      };
      return (m) => {
        if (m.type === 'init') {
          const ctx = m.canvas.getContext('2d');
          if (!ctx) return false;
          scene = new Scene(m, ctx);
        } else if (!scene) {
          return true;
        } else if (m.type === 'size') {
          scene.size(m.w, m.h, m.dpr);
        } else if (m.type === 'run') {
          if (running || scene.still) return true;
          running = true;
          last = 0;
          tick();
        } else if (m.type === 'stop') {
          running = false;
          clearTimeout(timer);
          timer = 0;
          if (raf) cancelAnimationFrame(raf);
          raf = 0;
        } else if (m.type === 'hush') {
          quiet = performance.now() + m.ms;
          if (raf) { cancelAnimationFrame(raf); raf = 0; last = 0; tick(); }
        }
        return true;
      };
    };

    let workerUrl = ''; // one Blob URL for every element on the page
    const used = new WeakSet(); // canvases already given a context or handed to a worker
    const ric = 'requestIdleCallback' in window;
    // On the page a frame costs a whole rendering pass, and a tap that lands behind one
    // waits for it (at 4x CPU, taps took p50 112 ms with the loop running, 88 ms
    // without), so a press or a key holds the on-page loop still for a quarter-second.
    // A worker's frames cost the page nothing and are never held.
    const onPage = new Set();
    const hush = () => { for (const handle of onPage) handle({ type: 'hush', ms: 250 }); };
    for (const type of ['pointerdown', 'keydown']) window.addEventListener(type, hush, { passive: true, capture: true });

    class TheodoreMesh extends HTMLElement {
      connectedCallback() {
        let canvas = this.querySelector('canvas');
        if (!canvas) return;
        // A canvas takes a context, or goes to a worker, only once: a reconnect (Horizon
        // or the theme editor re-rendering the section) starts on a fresh one.
        if (used.has(canvas)) {
          const fresh = document.createElement('canvas');
          canvas.replaceWith(fresh);
          canvas = fresh;
        }
        used.add(canvas);
        this.canvas = canvas;
        const conn = navigator.connection;
        const still = window.matchMedia('(prefers-reduced-motion: reduce)').matches || Boolean(conn && (conn.saveData || /2g/.test(conn.effectiveType || '')));
        this.init = {
          type: 'init',
          mode: ['mesh', 'contours', 'warp'].includes(this.dataset.mode) ? this.dataset.mode : 'warp',
          dark: this.dataset.scheme === 'black' || this.dataset.scheme === 'slate',
          still,
        };
        this.port = null;
        this.worker = null;
        this.handed = false;
        this.size = null;
        this.visible = false;
        this.running = false;
        this.ac = new AbortController();
        // The first observation sizes the canvas and draws the opening frame (the only
        // one when still); later ones follow the section's size.
        this.ro = new ResizeObserver((entries) => this.resize(entries[entries.length - 1].contentRect));
        this.ro.observe(this);
        if (still) return;
        // Animate only once the page has loaded and gone idle, and only near the viewport.
        const arm = () => {
          this.idle = 0;
          if (!this.isConnected || this.io) return;
          this.io = new IntersectionObserver((entries) => {
            this.visible = entries[entries.length - 1].isIntersecting;
            this.update();
          }, { rootMargin: '120px' });
          this.io.observe(this);
        };
        const idle = () => { this.idle = ric ? requestIdleCallback(arm, { timeout: 3000 }) : setTimeout(arm, 1200); };
        if (document.readyState === 'complete') idle();
        else window.addEventListener('load', idle, { once: true, signal: this.ac.signal });
        document.addEventListener('visibilitychange', () => this.update(), { signal: this.ac.signal });
      }
      disconnectedCallback() {
        if (this.ac) this.ac.abort();
        if (this.idle) { if (ric) cancelIdleCallback(this.idle); else clearTimeout(this.idle); }
        this.idle = 0;
        this.ro && this.ro.disconnect();
        this.io && this.io.disconnect();
        this.io = null;
        if (this.worker) this.worker.terminate();
        else if (this.port) this.port({ type: 'stop' });
        onPage.delete(this.port);
        this.worker = null;
        this.port = null;
        this.running = false;
      }
      resize(r) {
        if (!r.width || !r.height) return;
        const dpr = Math.min(window.devicePixelRatio || 1, 2);
        const s = this.size;
        if (s && s.w === r.width && s.h === r.height && s.dpr === dpr) return;
        this.size = { type: 'size', w: r.width, h: r.height, dpr };
        if (!this.port) this.open();
        this.port(this.size);
        this.update();
      }
      // Hands the canvas to a worker where the browser can, else draws here.
      open() {
        if (!this.init.still && 'transferControlToOffscreen' in this.canvas && typeof Worker === 'function') {
          let worker = null;
          try {
            workerUrl = workerUrl || URL.createObjectURL(new Blob(['const handle=(' + paintMesh + ')();onmessage=(e)=>{if(!handle(e.data))postMessage(0)};'], { type: 'text/javascript' }));
            worker = new Worker(workerUrl, { name: 'theodore-mesh' });
            const offscreen = this.canvas.transferControlToOffscreen();
            this.handed = true;
            // The worker only ever answers when it has no 2D context; an error means it
            // did not start, or failed. Either way the page takes over the drawing, and a
            // handled error is kept out of the page's own error reporting.
            worker.onmessage = worker.onerror = (e) => {
              if (e && e.type === 'error') e.preventDefault();
              if (this.worker !== worker) return;
              this.local();
              this.port(this.size);
              if (this.running) this.port({ type: 'run' });
            };
            worker.postMessage(Object.assign({}, this.init, { canvas: offscreen }), [offscreen]);
            this.worker = worker;
            this.port = (m) => worker.postMessage(m);
            return;
          } catch (e) {
            if (worker) worker.terminate();
          }
        }
        this.local();
      }
      // Draws on the page. A canvas already handed to a worker cannot be drawn on here,
      // so it gives way to a fresh one.
      local() {
        if (this.worker) this.worker.terminate();
        this.worker = null;
        if (this.handed) {
          const fresh = document.createElement('canvas');
          this.canvas.replaceWith(fresh);
          this.canvas = fresh;
          used.add(fresh);
          this.handed = false;
        }
        const handle = paintMesh();
        this.port = handle(Object.assign({}, this.init, { canvas: this.canvas })) ? handle : () => true;
        if (!this.init.still) onPage.add(this.port);
      }
      // The loop runs only while the section is near the screen and the tab is visible.
      update() {
        const run = Boolean(this.port && this.visible && !document.hidden);
        if (run === this.running) return;
        this.running = run;
        this.port({ type: run ? 'run' : 'stop' });
      }
    }
    customElements.define('theodore-mesh', TheodoreMesh);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["theodore-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('theodore-gallery')) {
    class TheodoreGallery extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.img = this.querySelector('.td-gallery__full');
        this.addEventListener('click', (e) => {
          const item = e.target.closest('.td-gallery__item');
          if (!item || !this.dialog || typeof this.dialog.showModal !== 'function') return;
          this.img.src = item.dataset.full;
          this.img.alt = item.dataset.alt || '';
          this.dialog.showModal();
        });
        this.dialog?.addEventListener('click', (e) => { if (e.target === this.dialog) this.dialog.close(); });
      }
    }
    customElements.define('theodore-gallery', TheodoreGallery);
  }

  } catch(e) { console.error(e); }
})();
})();
